import React  from 'react';
import {stringsTranslate} from "../../locales/CustomTranslater";
import {words} from "../../locales/Words";


export default function ContactSection() {
    const initData = {
        "heading": stringsTranslate(words.words.contact),
        "headingText": "",
        "headingTexttwo": "",
        "content": "",
        "iconList": [
            // {
            //     "id": 1,
            //     "iconClass": "fas fa-home",
            //     "text": "Tt. Vasumweg 292, 1033 SJ Amsterdam"
            // },
            {
                "id": 2,
                "iconClass": "fas fa-envelope",
                "text": "info@qrvehicle.com",
                action:"mailto:info@qrvehicle.com"
            },
            {
                "id": 3,
                "iconClass": "fas fa-phone-alt",
                "text": "+31 85 060 3668",
                action:"tel:0850603668"
            },
        ]
    }

        return (
            <section id="contact" className="contact-area bg-overlay ptb_100">
                <div className="container">
                    <div className="row justify-content-between">
                    <div className="col-12 col-md-5 order-1">
                        {/* Contact Us */}
                        <div className="contact-us">
                        <p className="mb-3">{initData.content}</p>
                            <ul>
                                {initData.iconList.map((item, idx) => {
                                    return(
                                        <li key={`ci_${idx}`} className="py-2">
                                            <a className="media" href={item.action}>
                                                <div className="social-icon bg-dark mr-3">
                                                    <i className={item.iconClass} />
                                                </div>
                                                <span className="media-body align-self-center fw-7 text-white">{item.text}</span>
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 pt-4 pt-md-0 order-0 ">
                        <div className="section-heading text-center mt-5 pt-2">
                            <h2 className="text-capitalize text-white">{initData.heading}</h2>
                            <h5 className="d-none d-sm-block mt-4 text-white">{initData.headingText}</h5>
                            <p className="d-block d-sm-none mt-4 text-white">{initData.headingTexttwo}</p>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        );
    }
